
import Message from "../../../assets/outline/Message.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageIcon({ className, dataTestid = "MessageIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Message data-testid={dataTestid} className={classes} {...rest} />
  );
}
